import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../../../../store';
import { PaymentSystemProps } from '../service/paymentSettings.interface';
import { paymentSettingsApi } from '../service/paymentSettings.api';

interface State {
    data: PaymentSystemProps[];
    formik: any;
}

const initialState: State = {
    formik: null,
    data: [],
};

export const paymentSystemSlice = createSlice({
    name: 'paymentSystemSelector',
    initialState,
    reducers: {
        updateForm(state, action) {
            state.formik = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addMatcher(
            paymentSettingsApi.endpoints.readPaymentSystems.matchFulfilled,
            (state, { payload }) => {
                state.data = payload;
            }
        );
    },
});

export const selectPaymentSystem = (state: RootState) =>
    state.paymentSystemSelector;

export const { updateForm } = paymentSystemSlice.actions;

export const paymentSystemReducer = paymentSystemSlice.reducer;
